import React from "react";
import cx from "clsx";
import { Transition } from "react-transition-group";

import TextFromBottom from "@/components/shared/text/textFromBottom";
import ProgressOuterSvg from "@/images/tour/progress-outer.svg";
import ProgressInnerSvg from "@/images/tour/progress-inner.svg";
import TriangleSvg from "@/images/tour/triangle-left.svg";

import globalStyles from "@/styles/global.module.scss";
import styles from "./desktop-tourProgress.module.scss";

const DesktopTourProgress = props => {
  const { percent, label, visible, labelVisible } = props;

  return (
    <Transition in={visible} timeout={0}>
      {state => (
        <div
          className={cx(
            styles.container,
            globalStyles.opacityAnimation,
            globalStyles[state]
          )}
        >
          <div className={styles.inner}>
            <ProgressOuterSvg
              className={styles.outerSvg}
              alt="Progress border"
            />
            <div className={styles.leftTri}>
              <TriangleSvg alt="Triangle" />
            </div>
            <div className={styles.mask}>
              <div
                className={cx(globalStyles.image, styles.progress)}
                style={{ width: `${percent}%` }}
              />
            </div>
            <ProgressInnerSvg
              className={cx(globalStyles.image, styles.innerSvg)}
              alt="Progress bar"
            />
          </div>

          <div className={styles.label}>
            <TextFromBottom visible={labelVisible}>{label}</TextFromBottom>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default DesktopTourProgress;
